export default __webpack_public_path__ + "static/media/Front-Khodor-Mazloum-Villa.e0f3b6df.jpg";